import { Position, Toaster } from "@blueprintjs/core";

export const AppToaster = Toaster.create({
  position: Position.TOP,
});
